import {useCallback, useEffect, useState} from "react"
import useEmblaCarousel, {UseEmblaCarouselType} from "embla-carousel-react"

type UseCarouselActions = {
    prevBtnDisabled: boolean
    nextBtnDisabled: boolean
    onPrevButtonClick: () => void
    onNextButtonClick: () => void
    emblaRef: UseEmblaCarouselType[0]
    emblaApi: UseEmblaCarouselType[1]
}

export const useCarouselActions = (): UseCarouselActions => {
    const [emblaRef, emblaApi] = useEmblaCarousel({})
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

    const onPrevButtonClick = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev()
    }, [emblaApi])

    const onNextButtonClick = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])

    const onSelect = useCallback(() => {
        setPrevBtnDisabled(!emblaApi?.canScrollPrev())
        setNextBtnDisabled(!emblaApi?.canScrollNext())
    }, [emblaApi])

    useEffect(() => {
        if (emblaApi) {
            onSelect()
            emblaApi.on("reInit", onSelect).on("select", onSelect)
            return () => {
                emblaApi.off("reInit", onSelect).off("select", onSelect)
            }
        }
    }, [emblaApi, onSelect])

    return {
        emblaRef,
        emblaApi,
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    }
}
